import { render } from "./WatchVideoJS.vue?vue&type=template&id=e48f040c&scoped=true"
import script from "./WatchVideoJS.vue?vue&type=script&lang=js"
export * from "./WatchVideoJS.vue?vue&type=script&lang=js"

import "./WatchVideoJS.vue?vue&type=style&index=0&id=e48f040c&scoped=true&lang=css"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48f040c"]])

export default __exports__